'use client';

import * as yup from 'yup';
import styled from "styled-components";
import CustomForm, { IFormInput } from "@/components/custorm-form";
import Input from "../../components/custorm-form/inputs/input";
import {useEffect, useState} from "react";
import { useRouter } from "next/navigation";
import {loginUser} from "@/components/api/auth";
import useStore from "@/components/store/store";
import Loader from "@/components/Loader";

export default function Auth() {
  const [loading, setLoading] = useState(false);
  const router = useRouter(); // <-- initialize router
  const [initializing, setInitializing] = useState(true);
  const {setUserInfo}=useStore();

  useEffect(() => {
    const storedUser = localStorage.getItem("userInfo");

    const timer = setTimeout(() => {
      if (storedUser) {
        router.push("/dashboard");
      }
      setInitializing(false);
    }, 7000);

    return () => clearTimeout(timer); // cleanup on unmount
  }, [router]);


  const schema = yup.object({
    phone_number: yup
      .string()
      .required("Phone number is required")
      .matches(/^\d+$/, "Phone number must contain only digits")
      .min(10, "Phone number must be at least 10 digits")
      .max(15, "Phone number must not exceed 15 digits"),

    password: yup
      .string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters long"),
  });

  const inputList: Array<IFormInput> = [
    {
      name: "phone_number",
      as: Input,
      placeholder: "Phone number",
    },
    {
      name: "password",
      as: Input,
      placeholder: "Password",
    },
  ];

  const initialValues = {
    phone_number: "",
    password: "",
  };

  async function handleSubmit(values: any) {
    setLoading(true);
    try {
      // Simulate login logic (replace with actual API call)
     const result = await loginUser(values);
      setUserInfo(result?.user_details)
      router.push("/dashboard");
    } catch (error) {
      // handle error
      console.error("Login failed:", error);
    } finally {
      setLoading(false);
    }
  }
if(initializing) return <Loader />
  return (
    <MainContainer>
      <InnerWrapper>
        <h2>Login</h2>
        <p>Manage sales, reports, and transactions—built for your workflow.</p>
        <CustomForm
          enableReinitialize={true}
          initialValues={initialValues}
          initialSchema={schema}
          onSubmitFunction={handleSubmit}
          loading={loading}
          formInputs={inputList}
          submitButtonText={"Login"}
        />
      </InnerWrapper>
    </MainContainer>
  );
}

const MainContainer = styled.div`
  width: 100%;
  height: 100vh;
  background: linear-gradient(to bottom, #ffffff, #b889d1);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const InnerWrapper = styled.div`
  background: #fff;
  padding: 32px;
  border-radius: 32px;
  width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  form{
    button{
      margin-top:1rem;
    }
  }
`;
